import React, { useEffect, useState } from 'react';
import {
  useNotification,
  showBackdropLoader,
  getDataGridHeading,
  pageSizeChangeHandler,
} from 'utils/commonUtils';
import {
  cannedResponsesColumns,
  getCannedResponsesListData,
} from './cannedResponsesListData';
import MDBox from 'components/MDBox';
import Card from '@mui/material/Card';
import {
  getCannedResponse,
  getCannedResponses,
  deleteCannedResponse,
  togglePinCannedResponse,
} from '../services/cannedResponsesApi';
import { useSelector } from 'react-redux';
import { intialPageSize } from 'constants';
import CannedResponseDialog from './CannedResponseDialog';
import CustomizedSnackbars from 'components/snackbar/Snackbar';
import DeltaDataGrid from 'utils/CommonDataGrid/CommonDataGrid';
import CommonDeleteDialog from 'components/Common/CommonDeleteDialog/CommonDeleteDialog';

const CannedResponsesComponent = () => {
  const availableUsersList = useSelector((state) => state.availableUsersList);
  const { NotificationPopup, handleErrorResponse } = useNotification();

  const [cannedResponsesListData, setCannedResponsesListData] = useState({
    isLoading: false,
    rows: [],
    pageSize: intialPageSize,
  });
  const [pinLoading, setPinLoading] = useState({});
  const [isFormLoading, setIsFormLoading] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [cannedResponseForm, setCannedResponseForm] = useState({});
  const [isNewCannedResponse, setIsNewCannedResponse] = useState(false);
  const [selectedCannedResponse, setSelectedCannedresponse] = useState('');
  const [openCannedResponsesDialog, setOpenCannedResponsesDialog] =
    useState(false);

  useEffect(() => {
    fetchCannedResponsesListData();
    setIsNewCannedResponse(false);
  }, []);

  const fetchCannedResponsesListData = async () => {
    try {
      setCannedResponsesListData((prev) => ({ ...prev, isLoading: true }));
      const data = await getCannedResponses();

      // Sort pinned items on top
      const sorted = getCannedResponsesListData(data, availableUsersList).sort(
        (a, b) => b.pinned - a.pinned
      );

      setCannedResponsesListData((prev) => ({
        ...prev,
        isLoading: false,
        rows: sorted,
      }));
    } catch (error) {
      setCannedResponsesListData((prev) => ({ ...prev, isLoading: false }));
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const handleNewCannedResponse = () => {
    setIsNewCannedResponse(true);
    setOpenCannedResponsesDialog(true);
  };

  const handleEdit = async (params) => {
    const { id } = params?.row;
    try {
      setIsFormLoading(true);
      const getData = await getCannedResponse(id);
      setCannedResponseForm(getData);
      setOpenCannedResponsesDialog(true);
      setIsFormLoading(false);
    } catch (error) {
      setIsFormLoading(false);
      handleErrorResponse(error?.response?.data?.message);
    }
  };

  const handleDelete = (params) => {
    const { id } = params?.row;
    setOpenDeleteDialog(true);
    setSelectedCannedresponse(id);
  };

  const updatePinnedState = (id, pinned) => {
    setCannedResponsesListData((prev) => {
      let updatedRows = prev.rows.map((row) =>
        row.id === id ? { ...row, pinned } : row
      );

      if (pinned) {
        // Move newly pinned item to the very top
        const pinnedItem = updatedRows.find((row) => row.id === id);
        updatedRows = [
          pinnedItem,
          ...updatedRows.filter((row) => row.id !== id),
        ];
      } else {
        // When unpinned, just re-sort normally
        updatedRows = [...updatedRows].sort((a, b) => b.pinned - a.pinned);
      }

      return { ...prev, rows: updatedRows };
    });
  };

  const handleTogglePin = async (params) => {
    const { id, pinned } = params?.row;

    setPinLoading((prev) => ({ ...prev, [id]: true }));

    try {
      await togglePinCannedResponse(id);
      updatePinnedState(id, !pinned);
      if (pinned) {
        fetchCannedResponsesListData();
      }
    } catch (error) {
      updatePinnedState(id, pinned); // revert
      handleErrorResponse(error?.response?.data?.message);
    } finally {
      setPinLoading((prev) => ({ ...prev, [id]: false }));
    }
  };

  const pageSizeChange = pageSizeChangeHandler(setCannedResponsesListData);

  return (
    <>
      <CustomizedSnackbars />
      {showBackdropLoader(isFormLoading)}
      <MDBox>
        {/* <Card> */}
        {getDataGridHeading('', 'New Canned Response', handleNewCannedResponse)}
        <DeltaDataGrid
          listData={cannedResponsesListData}
          columns={cannedResponsesColumns(
            handleEdit,
            handleDelete,
            handleTogglePin,
            pinLoading
          )}
          setListData={pageSizeChange}
        />
        {/* </Card> */}
      </MDBox>

      {openCannedResponsesDialog && (
        <CannedResponseDialog
          isFormLoading={isFormLoading}
          open={openCannedResponsesDialog}
          setOpen={setOpenCannedResponsesDialog}
          cannedResponseForm={cannedResponseForm}
          isNewCannedResponse={isNewCannedResponse}
          setCannedResponseForm={setCannedResponseForm}
          setIsNewCannedResponse={setIsNewCannedResponse}
          fetchCannedResponsesListData={fetchCannedResponsesListData}
        />
      )}

      <CommonDeleteDialog
        snakBarName="canned response"
        openDeleteDialog={openDeleteDialog}
        commonDeleteApi={deleteCannedResponse}
        commonDeleteId={selectedCannedResponse}
        fetchData={fetchCannedResponsesListData}
        setOpenDeleteDialog={setOpenDeleteDialog}
        contentText="Are you sure you want to delete this canned response?"
      />

      <NotificationPopup />
    </>
  );
};

export default CannedResponsesComponent;
